import { ConsultaPesquisaCirg } from '../consultaPesquisaCirg/types';
import { RetornoCivil } from '../consultaPesquisaCivil/types';

export enum Types {
	CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_REQUEST = '@iirgd/CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_REQUEST',
	CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_SUCCESS = '@iirgd/CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_SUCCESS',
	CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_FAILURE = '@iirgd/CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_FAILURE',
	CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_CLEAR = '@iirgd/CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_CLEAR',
}

export interface IConsultaPesquisaCidadaoKitFamiliaState {
	status: number;
	data: ConsultaPesquisaCidadaoResponse[] | null;
	dataFailure: ConsultaPesquisaCidadaoFailureResponse | null;
}

export interface ConsultaPesquisaCidadaoResponse {
	pesquisaCIRG: ConsultaPesquisaCirg[];
	pesquisaCivil: RetornoCivil;
}

export interface ConsultaPesquisaCidadaoFailureResponse {
	status: number;
	trace: string;
	messages: string[];
}

export interface IUsuario {
	usuario: string;
	senha: string;
}
